var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{directives:[{name:"status",rawName:"v-status",value:(_vm.meta.permission_prefix + 'edit'),expression:"meta.permission_prefix + 'edit'"}],staticClass:"btn btn-outline-primary btn-sm",on:{"click":function($event){return _vm.actions(_vm.data , 'edit')}}},[_c('i',{staticClass:"fa fa-pencil-alt"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }